import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useLocation } from "react-router-dom";
import CustomerRegistration from "../CustomerRegistraion";
import Payment from "../Payment";
import OrderConfirmation from "../OrderConfirmation";
import { getApiHeader } from "utlis/commonfunctions";
import axios from "axios";

const steps = ["Customer Registration", "Payment details", "Review your order"];

const OrderCheckout = () => {
    const [activeStep, setActiveStep] = useState(0);
    const apiUrl = process.env.REACT_APP_API_URL;

    const location = useLocation();
    const [stateData, setStateData] = useState(() => location.state?.stateData || {
        plan_name: "N/A",
        actual_amount: 0,
        plan_validity: 0,
    });

    // let totalPrice = `AU $${stateData.plan_amount}`;

    const [paymentMethodToken, setPaymentMethodToken] = useState(null);
    const [orderSuccessData, setOrderSuccessData] = useState(null);
    const [totalZero ,setTotalZero] = useState(false);

    
    const [products, setProducts] = useState([
        { name: stateData.plan_name, desc: "", price: `AU $${stateData.plan_amount}` },
        { name: "Plan Validity", desc: "", price: `${stateData.plan_validity} Days` },
        { name: "Subtotal", desc: "", price: `AU $${stateData.plan_amount}` },
    ]);
    
    const [totalPrice, setTotalPrice] = useState(stateData.plan_amount); 

    
    function getStepContent(step) {
        switch (step) {
            case 0:
                return <CustomerRegistration planData={stateData} totalZero={totalZero}  handleParOrderSuccessData={handleParOrderSuccessData} onFormSubmit={handleFormSubmit} />;
            case 1:
                return <Payment paymentMethodToken={paymentMethodToken} onPaymentSubmit={handleOrderSuccessData} />;
            case 2:
                return <OrderConfirmation orderSuccessData={orderSuccessData} />;
            default:
                throw new Error("Unknown step");
        }
    }


    const handleFormSubmit = (token) => {
        setPaymentMethodToken(token);
        setActiveStep((prevStep) => prevStep + 1);
    };

    const handleParOrderSuccessData = (data) => {
        setOrderSuccessData(data);
        setActiveStep((prevStep) => prevStep + 2);
    };

    const handleOrderSuccessData = (data) => {
        setOrderSuccessData(data);
        setActiveStep((prevStep) => prevStep + 1);
    };

    const handleNext = () => {
        setActiveStep((prevStep) => prevStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevStep) => prevStep - 1);
    };

    const getWalletCreditUsed = async () => {
        const headers = await getApiHeader();
        try {
            const response = await axios.post(
                `${apiUrl}international-esim/get-wallet-credit-used`,
                { amount: stateData.plan_amount },
                { headers }
            );

            if (response.data?.status === 200) {
                const { wallet_credit_used, card_used_amount , retailer_type} = response.data.data;

                console.log('card_used_amount--->',card_used_amount);
                

                const updatedProducts = [
                    { name: stateData.plan_name, desc: "", price: `AU $${stateData.plan_amount}` },
                    { name: "Plan Validity", desc: "", price: `${stateData.plan_validity} Days` },
                   
                ];

                if (wallet_credit_used > 0) {
                    updatedProducts.push(
                       
                        { name: "Subtotal", desc: "", price: `AU $${card_used_amount.toFixed(2)}` }
                    );
                    setTotalPrice(card_used_amount); 
                    if (card_used_amount === 0) {
                        setTotalZero(true);
                    }
                } else {
                    updatedProducts.push(
                        { name: "Subtotal", desc: "", price: `AU $${(parseFloat(stateData.plan_amount) || 0).toFixed(2)}`}
                    );
                    setTotalPrice(stateData.plan_amount); 
                }
                if (retailer_type !== 'PAR') {
                    updatedProducts.push({
                        name: "Wallet Credit Used",
                        desc: "",
                        price: `AU $${(parseFloat(wallet_credit_used) || 0).toFixed(2)}`
                    });
                }
                

                setProducts(updatedProducts); 
            } else {
                console.log("Unexpected response:", response);
            }
        } catch (error) {
            console.log('Error------->', error);
        }
    };
    

    useEffect(() => {
        if (location.state?.stateData) {
            setStateData(location.state.stateData);
        }
        
        getWalletCreditUsed()

    }, [location.state]);

    

   



    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div style={{ margin: "20px", padding: "20px", borderRadius: "20px", minHeight: "100vh", paddingTop: "3rem", boxShadow: "rgb(204, 219, 232) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset" }}>
                {/* Page Title */}
                <div
                    className="text-center mb-5"
                    style={{
                        fontSize: "2.5rem",
                        fontWeight: "bold",
                        background: "linear-gradient(90deg, #ff512f, #dd2476)",
                        WebkitBackgroundClip: "text",
                        color: "#c11d6c",
                        textTransform: "uppercase",
                        letterSpacing: "2px",
                    }}
                >
                    Order Checkout
                </div>

                <div className="container mt-5">
                    <div className="row gx-4 gy-4">
                        {/* Main Content Area */}
                        <div
                            className="col-12 col-lg-8 order-checkout-main-content d-flex flex-column"
                            style={{
                                alignItems: "flex-start",
                                padding: "0rem 1rem",
                                gap: "1rem",
                            }}
                        >
                            <div className="flex-grow-1 w-100" style={{ maxWidth: "700px" }}>
                                {getStepContent(activeStep)}
                            </div>
                        </div>

                        {/* Sidebar */}
                        <div
                            className="col-12 col-lg-4 order-checkout-sidebar"
                            style={{
                                backgroundColor: "#ffffff",
                                borderRadius: "20px",
                                boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
                                padding: "2rem",
                                gap: "1.5rem",
                            }}
                        >
                            {/* Sidebar Title */}
                            <div className="text-center mb-4">
                                <h4
                                    className="text-dark"
                                    style={{
                                        fontWeight: "700",
                                        textTransform: "uppercase",
                                        letterSpacing: "1px",
                                        display: "inline-block",
                                        paddingBottom: "8px",
                                    }}
                                >
                                    Order Summary
                                </h4>
                            </div>

                            
                            <div className="w-100" style={{ maxWidth: "500px" }}>
                                <ul className="list-unstyled">
                                    {products.map((product) => (
                                        <li
                                            key={product.name}
                                            className="d-flex justify-content-between align-items-center py-2"
                                            style={{
                                                borderBottom: "2px dashed #ccc",
                                                paddingBottom: "10px",
                                                marginBottom: "10px",
                                                transition: "background-color 0.3s",
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = "#f8f9fa";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = "transparent";
                                            }}
                                        >
                                            <div style={{ maxWidth: "70%", }}>
                                                <strong style={{ color: "#495057", fontSize: '16px', fontWeight: "400" }}>
                                                    {product.name}
                                                </strong>
                                                <p className="mb-0 text-muted" style={{ fontSize: "16px", whiteSpace: "normal", overflowWrap: "break-word" }}>
                                                    {product.desc}
                                                </p>
                                            </div>
                                            <span className="fw-medium" style={{ color: "#495057", fontSize: "16px" }}>
                                                {product.price}
                                            </span>
                                        </li>
                                    ))}
                                </ul>


                                <div
                                    className="d-flex justify-content-between fw-bold mt-3"
                                    style={{
                                        paddingTop: "10px",
                                    }}
                                >
                                    <span style={{ fontSize: "1.4rem", color: "#343a40" }}>TOTAL</span>
                                    <span className="text-danger h5 fw-bold" style={{ fontSize: "1.6rem", color: "#c11d6c!important" }}>{`AU $${(parseFloat(totalPrice) || 0).toFixed(2)}`}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </DashboardLayout>
    );
};

export default OrderCheckout;
